import React, { useEffect, useState } from "react";
import axios from "axios";
import { environment } from "../utility/environment";
import { initDataProp } from "../utility/service/api-service";
import { checkDpSuccess } from "../utility/service/tool-service";

const GoogleCaptchaV3 = ({siteKey='',setSiteKey}) => {
  // const siteKey = "6LeT4ZAqAAAAAKbYVgK31iUAj5DNknaePbiexFE5";
  const [token, setToken] = useState("");
  
  useEffect(() => {
    // 載入 reCAPTCHA 腳本
    const script = document.createElement('script');
    if(siteKey===''|| siteKey===undefined){
      initDataProp({reqType:'siteKey'})
      .then((res)=>{
        if(checkDpSuccess(res)){
          let data = res?.data?.RespBody;
          setSiteKey(data.sitekeyV3);
          script.src = `https://www.google.com/recaptcha/api.js?render=${data?.sitekeyV3}`;
          script.async = true;
          script.defer = true;
          document.body.appendChild(script);
        }
        
      })
    }
   
    // 清理函數：完全移除 reCAPTCHA 相關資源
    return () => {
      // 移除腳本
      if (script && document.body.contains(script)) {
        document.body.removeChild(script);
      }
  
      // 移除 reCAPTCHA 的 iframe
      const recaptchaIframes = document.querySelectorAll('iframe[src*="recaptcha"]');
      recaptchaIframes.forEach(iframe => {
        iframe.remove();
      });
  
      // 移除 reCAPTCHA 的 badge
      const recaptchaBadge = document.querySelector('.grecaptcha-badge');
      if (recaptchaBadge) {
        recaptchaBadge.remove();
      }
  
      // 清理全域變數
      if (window.grecaptcha) {
        delete window.grecaptcha;
      }
  
      // 移除可能遺留的 reCAPTCHA 相關樣式
      const recaptchaStyles = document.querySelectorAll('style[data-id="recaptcha-v3-styles"]');
      recaptchaStyles.forEach(style => {
        style.remove();
      });
    };
  }, [siteKey]);

 

  // useEffect(() => {
  //   // 載入 Google reCAPTCHA v3 的腳本
  //   const loadRecaptcha = () => {
  //     const script = document.createElement("script");
  //     script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
  //     script.async = true;
  //     document.body.appendChild(script);
  //     return script;
  //   };

  //   // 立即載入腳本
  //   const scriptElement = loadRecaptcha();

  //   // 清理 reCAPTCHA 的全局狀態
  // const cleanupRecaptcha = () => {
  //   if (window.grecaptcha) {
  //     // 假設 reCAPTCHA 的 API 提供了某種清理機制，可以調用它來清理狀態
  //     // 目前，reCAPTCHA 並未提供官方的 API 清除方法，所以只能依賴移除腳本
  //     delete window.grecaptcha;
  //   }

  //   // 移除腳本
  //   if (scriptElement) {
  //     document.body.removeChild(scriptElement);
  //   }
  // };

  // // 當畫面離開或組件卸載時，移除該腳本並清理狀態
  // return cleanupRecaptcha;

  // }, []);

 
  return (
    <>
    </>
  );
};

export default GoogleCaptchaV3;